// Plain words for moderation checks, failures and switches, shared by the
// composer panel and the Command Center override dialog. Nothing here
// fetches or renders.

const CHECK_WORDS = {
  phrase: 'Phrase rules',
  provider_text: 'Text',
  provider_image: 'Images',
  provider_video: 'Video',
  provider_audio: 'Soundtrack',
}

// checkWords names one moderation check (an exemption's checks_covered
// entry); an unknown check is spelled out from its code.
export function checkWords(check) {
  if (!check) return ''
  return CHECK_WORDS[check] || String(check).replaceAll('_', ' ')
}

export function checksWords(checks = []) {
  return (checks || []).map(checkWords).filter(Boolean).join(', ')
}

// checkListWords names checks inside a sentence: "text", "text and images",
// "text, images and video".
export function checkListWords(checks = []) {
  const words = (checks || []).map((check) => checkWords(check).toLowerCase()).filter(Boolean)
  if (words.length <= 1) return words[0] || ''
  return `${words.slice(0, -1).join(', ')} and ${words[words.length - 1]}`
}

// Failure codes by what fixes them. Three lists, mirroring the server's:
// the content classes ('media', 'content', 'scope') are
// moderation.ContentJobErrors, failures the post itself causes, which no
// outage release covers; 'refused' is provider_result_refused, the one
// code in moderation.DeterministicJobErrors that is not a content error: a
// result the flag-only rule refuses, never re-submitted (a retry would pay
// for the same answer) yet the provider's fault, so the server's outage
// evidence (moderation_admin_service.go outageEvidence) accepts it for a
// release; every other recorded code is an 'outage', retried on its own.
const FAILURE_CLASSES = {
  input_missing: 'media',
  video_undecodable: 'media',
  audio_undecodable: 'media',
  provider_input_rejected: 'content',
  scope_unresolved: 'scope',
  provider_result_refused: 'refused',
}

// checkFailureClass says what a failed check needs: 'media' (replace it),
// 'content' (change it), 'scope' (fix the regulations), 'refused' (a Wager
// fix of the provider, or a Wager release; never retried on its own) or
// 'outage' (wait for the provider, or a Wager release).
export function checkFailureClass(code) {
  return FAILURE_CLASSES[code] || 'outage'
}

// providerFaultFailure reports a failed check that is the provider's fault,
// which Wager may release the post past: an outage, or a refused result.
export function providerFaultFailure(code) {
  const failureClass = checkFailureClass(code)
  return failureClass === 'outage' || failureClass === 'refused'
}

const NOT_ENFORCED_SENTENCES = {
  platform_off: 'Wager has switched content moderation off for every brand',
  platform_shadow: 'Wager is running content moderation in observe-only mode',
  org_off: 'Moderation is off for this brand',
}

// notEnforcedSentence names the switch that keeps moderation from
// enforcing a post, as the start of a sentence; a missing reason reads as
// the brand's switch.
export function notEnforcedSentence(reason) {
  return NOT_ENFORCED_SENTENCES[reason] || NOT_ENFORCED_SENTENCES.org_off
}
